__webpack_require__.p = "/summer-school/fr/";